import { BRAND } from '@onuw/roles-data'

const title = `Join the table – ${BRAND.name}`
const description = `You're invited to a game of ${BRAND.name}. Open the link on any phone or computer to take a seat: free, no sign-up.`

/**
 * The meta of an invite link's page (/r/<code>): the room route's, and the root's too, since Pages answers an
 * invite link with the SPA fallback (public/_redirects), which renders the root route alone, and that page is all
 * a link preview reads (it runs no script).
 */
export const inviteMeta = () => [
  { title },
  { name: 'description', content: description },
  { property: 'og:title', content: title },
  { property: 'og:description', content: description },
  { name: 'robots', content: 'noindex' },
]
